import { BrowserSessionApiClient } from './browserSessionApiClient';

const apiBaseUrl = (import.meta.env.VITE_API_BASE_URL || '/api').replace(/\/+$/, '');
const client = new BrowserSessionApiClient(apiBaseUrl);
export const localProjectFolderUrl = (projectId: number) => {
  if (!Number.isSafeInteger(projectId) || projectId <= 0 || projectId > 2147483647) throw new Error('Invalid project ID');
  return `le-admin://open/project/${projectId}`;
};
export async function refreshProjectFolderStatus(projectId: number) {
  localProjectFolderUrl(projectId); // Apply the same numeric ID bounds to publication.
  const response = await client.request<{
    success: boolean;
    data: { webUrl: string | null; status: { projectId: number; sharePointUrl: string | null; updatedAtDisplay: string } };
  }>(`${apiBaseUrl}/v1/projects/${projectId}/folders/status`, { method: 'POST' });
  if (response?.success !== true || response.data?.status?.projectId !== projectId
    || typeof response.data.status.updatedAtDisplay !== 'string') throw new Error('PMApp did not confirm folder status publication.');
  return response.data;
}
